import * as propertyTypes from "../property_types.js"

export class UiTab extends propertyTypes.Serializable {

    private titleMetadata = new propertyTypes.TranslatableTextProperty("title", "Title");
    public title: string;

    private visibleMetadata = new propertyTypes.TextCheckboxProperty("visible", "Visible");
    public visible: string;

    private moduleNameMetadata = new propertyTypes.TextProperty("moduleName", "Module name");
    public moduleName: string;

    private componentMetadata = new propertyTypes.TextProperty("component", "Component");
    public component: string;

    private iconNameMetadata = new propertyTypes.FontawesomeIconProperty("iconName", "Icon name");
    public iconName: string;

    private helpUrlMetadata = new propertyTypes.TemplateProperty("helpUrl", "Help url");
    public helpUrl: string;

    private metadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.metadata = [this.titleMetadata, this.visibleMetadata, this.moduleNameMetadata, this.iconNameMetadata, this.componentMetadata, this.helpUrlMetadata];
    }

    hasErrors(): boolean {
        const meta = this.getMetadata();

        for (let x of meta) {
            let value = this[x.ValueField];

            if (x.IsMandatory && !value) {
                return true;
            }
        }
        return false;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadata;
    }
}